import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface UserReview {
  name: string;
  message: string;
  avatarUrl: string;
  rate: number;
  subtitle?: string;
}

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-user-review',
  templateUrl: './user-review.component.html',
  styleUrl: './user-review.component.scss'
})
export class UserReviewComponent {
  @Input() data: UserReview;
}
